import api from '@/service/api'
console.log('api:', api)
export default {
  namespaced: true,
  state() {
    return {

    }
  },
  mutations: {

  },
  getters: {

  },
  actions: {
    getShopMap({ commit }, param) {
      return api.getShopMap(param)
    },
    getTapeImageList({ commit }, param) {
      return api.getTapeImageList(param)
    },
    createTapeOrder({ commit }, param) {
      return api.createTapeOrder(param)
    },
    deleteTapeOrder({ commit }, payload) {
      return api.deleteTapeOrder(payload)
    },
    handleTapeOrder({ commit }, payload) {
      return api.handleTapeOrder(payload)
    },
    postTapeProject({ commit }, tapeProject) {
      return api.postTapeProject(tapeProject)
    },
    getTapeProject({ commit }, params) {
      return api.getTapeProject(params)
    },
    deleteTapeProject({ commit }, param) {
      return api.deleteTapeProject(param)
    },
    getOrder({ commit }, param) {
      return api.getOrder(param)
    },
    getTapeOrder({ commit }, payload) {
      return api.getTapeOrder(payload)
    },
    exportTapeProjectPoints({ }, param) {
      return api.exportTapeProjectPoints(param)
    },
    putTapeShop({ }, param) {
      return api.putTapeShop(param)
    },
  }
}